import Login from './login/login';
import Registration from './registration/registration';
import RegistrationManager from './registration/registrationManager';
import PasswordReset from './password-reset/password-reset';
import EmptyPermissions from './empty-permissions/empty-permissions';
import EmailUnverified from './email-unverified/email-unverified';
import PrivacyPolicy from './docs/privacyPolicy';
import TermsConditions from './docs/termsConditions';

export default [
  {
    name: 'login',
    path: '/auth/login',
    component: Login,
    meta: { unauth: true },
  },
  {
    name: 'passwordReset',
    path: '/auth/password-reset',
    component: PasswordReset,
    meta: { unauth: true },
  },
  {
    name: 'registrationManager',
    path: '/auth/registrationManager',
    component: RegistrationManager,
    meta: { unauth: true },
  },
  {
    name: 'registration',
    path: '/auth/registration',
    component: Registration,
    meta: { unauth: true },
  },
  {
    name: 'emailUnverified',
    path: '/auth/email-unverified',
    component: EmailUnverified,
    meta: { auth: true, emailAlreadyVerified: true },
  },
  {
    name: 'emptyPermissions',
    path: '/auth/empty-permissions',
    component: EmptyPermissions,
    meta: { auth: true, notEmptyPermissions: true },
  },
  {
    name: 'privacyPolicy',
    path: '/auth/privacyPolicy',
    component: PrivacyPolicy,
    meta: { unauth: true },
  },
  {
    name: 'termsConditions',
    path: '/auth/termsConditions',
    component: TermsConditions,
    meta: { unauth: true },
  },
];



// WEBPACK FOOTER //
// ./src/auth/auth-routes.js